import {DiContainer} from "./utils/di-container.js";

/**
 * Main application context / container. Use to inject services and other objects.
 * @type {DiContainer}
 */
export const appContext = new DiContainer();
